module.exports = __webpack_public_path__ + "img/iconmedan.57804861.png";